/* eslint-disable indent */
import { InboxMessage } from '@src/main/modules/messages/domain/message/inbox/inbox-message.interface';
import { Message } from '@src/main/modules/messages/domain/message/message.interface';
import { FormattedMessage } from '@src/main/modules/messages/ui/mailbox/model/formated-message.model';
import { makeDateBodyTemplate } from '@src/main/modules/messages/utils/templates';
import TextWithTooltip from '@src/main/shared/ui/components/text/TextWithTooltip';
import { TFunction } from 'i18next';
import { ColumnFilterElementTemplateOptions } from 'primereact/column';
import { ReactNode } from 'react';

export const getSendDateColumnProps = (
  t: TFunction,
  dateFilterTemplate: (options: ColumnFilterElementTemplateOptions) => ReactNode,
) => ({
  field: 'sendDate',
  header: t('messages.mailbox.date'),
  body: makeDateBodyTemplate('sendDate'),
  filter: true,
  filterField: 'sendDate',
  filterElement: dateFilterTemplate,
  showFilterOperator: false,
  showAddButton: false,
  showFilterMatchModes: false,
  dataType: 'date',
  style: { minWidth: '12rem' },
  sortable: true,
});

export const getSubjectColumnProps = <T extends FormattedMessage>(t: TFunction) => ({
  field: 'subject',
  header: t('messages.mailbox.subject'),
  filter: true,
  filterField: 'subject',
  showFilterOperator: false,
  showAddButton: false,
  showFilterMatchModes: false,
  style: { minWidth: '12rem' },
  sortable: true,
  body: (rowData: T) => <TextWithTooltip content={rowData.subject} maxLength={40} tooltip />,
});

export const getSendByColumnProps = <T extends FormattedMessage>(t: TFunction) => ({
  field: 'sendBy',
  header: t('messages.mailbox.sentBy'),
  filter: true,
  filterField: 'sendBy',
  showFilterOperator: false,
  showAddButton: false,
  showFilterMatchModes: false,
  style: { minWidth: '12rem' },
  sortable: true,
  body: (rowData: T) => <TextWithTooltip content={rowData.sendBy} maxLength={40} tooltip />,
});

export const getRecipientsColumnProps = <T extends Message>(
  t: TFunction,
  body: (rowData: T) => ReactNode,
) => ({
  field: 'recipients',
  header: t('messages.mailbox.recipients'),
  filter: true,
  filterField: 'recipients',
  showFilterOperator: false,
  showAddButton: false,
  showFilterMatchModes: false,
  body,
  style: { minWidth: '16rem' },
});

export const getMessageColumnProps = <T extends FormattedMessage>(t: TFunction) => ({
  field: 'message',
  header: t('messages.mailbox.message'),
  filter: true,
  filterField: 'message',
  showFilterOperator: false,
  showAddButton: false,
  showFilterMatchModes: false,
  style: { minWidth: '20rem' },
  sortable: true,
  body: (rowData: T) => <TextWithTooltip content={rowData.message} maxLength={100} tooltip />,
});

export const getAttachmentColumnProps = <T extends Message>(
  t: TFunction,
  body: (rowData: T) => ReactNode,
) => ({
  field: 'keyAttachment',
  header: t('messages.mailbox.attachment'),
  body,
  style: { minWidth: '10rem' },
});

export const getReplyColumnProps = (t: TFunction, body: (rowData: InboxMessage) => ReactNode) => ({
  header: t('messages.mailbox.reply'),
  body,
  style: { minWidth: '10rem', textAlign: 'center' as const },
});

export const getInitDateColumnProps = (t: TFunction) => ({
  field: 'initDate',
  header: t('messages.mailbox.validFrom'),
  filter: true,
  filterField: 'initDate',
  showFilterOperator: false,
  showAddButton: false,
  showFilterMatchModes: false,
  body: makeDateBodyTemplate('initDate'),
  style: { minWidth: '12rem' },
  sortable: true,
});

export const getEndDateColumnProps = (t: TFunction) => ({
  field: 'endDate',
  header: t('messages.mailbox.validTo'),
  filter: true,
  filterField: 'endDate',
  showFilterOperator: false,
  showAddButton: false,
  showFilterMatchModes: false,
  body: makeDateBodyTemplate('endDate'),
  style: { minWidth: '12rem' },
  sortable: true,
});
